var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.282,
    viewBox: "0 0 18 17.282",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9237",
    "data-name": "Path 9237",
    d: "M3.937,5.663H1.125A1.125,1.125,0,0,0,0,6.788V10.6a1.125,1.125,0,0,0,1.125,1.125H3.937A1.125,1.125,0,0,0,5.062,10.6V6.788A1.125,1.125,0,0,0,3.937,5.663ZM11.531,10.6V6.788a1.125,1.125,0,0,0-1.125-1.125H7.594A1.125,1.125,0,0,0,6.469,6.788V10.6a1.125,1.125,0,0,0,1.125,1.125h2.812A1.125,1.125,0,0,0,11.531,10.6Zm5.344-4.937H14.062a1.125,1.125,0,0,0-1.125,1.125V10.6a1.125,1.125,0,0,0,1.125,1.125h2.812A1.125,1.125,0,0,0,18,10.6V6.788A1.125,1.125,0,0,0,16.875,5.663ZM8.53,2.972a.591.591,0,0,0-.877.191.562.562,0,0,0,.253.754l1.125.562a.562.562,0,0,0,.7-.166l.844-1.125a.562.562,0,0,0-.112-.787.588.588,0,0,0-.866.217A3.937,3.937,0,0,0,1.969,3.976a.562.562,0,1,0,1.125,0,2.812,2.812,0,0,1,5.437-1Zm7.67,10.1a.562.562,0,0,0-.7-.166l-1.125.562a.562.562,0,0,0-.253.754.591.591,0,0,0,.877.191,2.812,2.812,0,0,1-5.437-1,.562.562,0,1,0-1.125,0,3.937,3.937,0,0,0,7.627,1.358.588.588,0,0,0,.866.217.562.562,0,0,0,.112-.787Zm-1.409-8.7a.562.562,0,0,0,.734.053l2.25-1.687a.562.562,0,0,0-.675-.9L15.241,3.245l-.5-.509a.562.562,0,0,0-.793.793Zm-10.8,9.435-1.125-.844a.562.562,0,0,0-.675,0l-1.125.844a.562.562,0,0,0-.112.787c.273.371.731.225,1.012-.056v1.687a.562.562,0,0,0,1.125,0V14.538c.281.281.74.427,1.012.056a.562.562,0,0,0-.112-.787Z",
    transform: "translate(0 -0.054)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalIcon);
export default __webpack_public_path__ + "static/media/Approval_Icon.846c427b70db9a268de97bbaac43487f.svg";
export { ForwardRef as ReactComponent };